/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';
import {fallbackResponse} from './fallbackResponse.js'
const addNesting = (d: number) => {
  if (d == 0) {
    return ''; 
  } 

  return `
    children {
      __typename
      ... on NavContentNode {
        ...ContentNode
        ${addNesting(d - 1)}
      }
    }
  `
}

export const makeQuery = (d: number) => gql`
  query GetMenuItems($id: String!) {
    navRoot(id: $id) {
      ${addNesting(d)}
    }
  }

  fragment ContentNode on NavContentNode {
    __typename
    title
    thumbnail
    description
    type
    link {
      __typename
      label
      ... on NavCategoryLink {
        category {
          seo_token_ntk
          id
          identifier
          slug
          __typename
          parentCategory {
                id
                identifier
          }
        }
        __typename
      }
      ... on NavUrlLink {
        url
        __typename
      }
    }
    children {
      ... on NavContentNode {
        title
        thumbnail
        description
        link {
          __typename
          label
          ... on NavCategoryLink {
            category {
              seo_token_ntk
              id
              identifier
              slug
              __typename
              parentCategory {
                id
                identifier
              }
            }
            __typename
          }
          ... on NavUrlLink {
            url
            __typename
          }
        }
        type
        children {
          ... on NavContentNode {
            title
            thumbnail
            type
            description
            link {
              __typename
              label
              ... on NavCategoryLink {
                category {
                seo_token_ntk
                  id
                  identifier
                  slug
                  __typename
                  parentCategory {
                    id
                    identifier
                  }
                }
                __typename
              }
              ... on NavUrlLink {
                url
                __typename
              }
            }
            children {
              ... on NavContentNode {
                title
                thumbnail
                type
                description
                link {
                  __typename
                  label
                  ... on NavCategoryLink {
                    category {
                    seo_token_ntk
                      id
                      identifier
                      slug
                      __typename
                      parentCategory {
                        id
                        identifier
                      }
                    } 
                    __typename
                  }
                  ... on NavUrlLink {
                    url
                    __typename
                  }
                }
              }
              ... on NavDelimiterNode {
                type
              }
            }
          }
          ... on NavDelimiterNode {
            type
          }
        }
      }
      ... on NavDelimiterNode {
        type
      }
    }
  }
`;

export type NavContentNode = {
  __typename: string;
  title: string;
  thumbnail?: string;
  description?: string;
  type?: string;
  link: {
    __typename: string;
    label: string;
    url: string;
    category?: {
      seo_token_ntk: string;
      id: string;
      identifier: string;
      slug: string;
      parentCategory : {
        id: string;
        identifier: string;
      }
    };
  };
  children?: NavContentNode[];
};

export const useNavigation = (id: string, depth=3, skipCondition = false) => {
  const resolvedId = id || "main";
  const { loading, error, data } = useQuery<{ navRoot: { children: NavContentNode[] } }>(
    makeQuery(depth),
    {
      variables: { id: resolvedId },
      skip: skipCondition,
      context:{clientName:"catalog"}
    }
  );


  if(error){
    return { loading: false, error: undefined, data: data ? data : fallbackResponse };
  }

  return { loading, error, data:  data?.navRoot?.children?.length > 0  ?  data : fallbackResponse };
};
